import React from "react";
import { CommonMonthlyPriceLabelKey } from "../../../../../../common-deprecated/priceUtils";
import { getAemMonthlyRateFormat } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { useUscSelector } from "../../../../redux/store";
import { formatMonthlyFinancePrice } from "../../../../../shared-logic/utils/uscPriceUtils";
import { UscDisclaimerType } from "../../../../../shared-logic/types/UscCommonTypes";
import LinkTextDisclaimer from "../LinkTextDisclaimer";
import * as Styles from "./UscMonthlyPriceDisclaimer.styles";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";

type UscInlineMonthlyPriceType = {
    inBasketDetails?: boolean;
};

const UscInlineMonthlyPrice = ({ inBasketDetails }: UscInlineMonthlyPriceType): JSX.Element | null => {
    const financeInfo = useUscSelector((state) => state.finance.info);
    const monthlyPrice = useUscSelector((state) => state.finance.monthlyPrice);
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const monthlyPriceFormat = getAemMonthlyRateFormat(commonSettings, AemFmComponent.Pdp, vehicleType);

    const { monthlyFinanceLabels } = financeInfo
        ? formatMonthlyFinancePrice(monthlyPrice, commonSettings, financeInfo, monthlyPriceFormat)
        : { monthlyFinanceLabels: [] };

    const hasDisclaimers = !!monthlyFinanceLabels?.length;

    if (!hasDisclaimers) return null;

    return (
        <Styles.MonthlyWrapper inBasketDetailsModal={inBasketDetails}>
            <Styles.MultiplePrices>
                {monthlyFinanceLabels.map(({ key, value }) => {
                    switch (key) {
                        case CommonMonthlyPriceLabelKey.Price:
                            return (
                                <Text tag="div" variant={inBasketDetails ? "h7" : "button-semibold"} key={key}>
                                    <div dangerouslySetInnerHTML={{ __html: value }} />
                                </Text>
                            );

                        case CommonMonthlyPriceLabelKey.Disclaimer:
                            return (
                                <Styles.DisclaimerWrapper spacingTop>
                                    <LinkTextDisclaimer type={UscDisclaimerType.Finance} />
                                </Styles.DisclaimerWrapper>
                            );

                        default:
                            return (
                                <Text tag="div" variant={inBasketDetails ? "body-small-book" : "button-book"}>
                                    <div dangerouslySetInnerHTML={{ __html: value }} />
                                </Text>
                            );
                    }
                })}
            </Styles.MultiplePrices>
        </Styles.MonthlyWrapper>
    );
};

export default UscInlineMonthlyPrice;
